import validate from "/usr/src/app/content/n3-promos-292b23bb-0511-480b-8a2c-48cdf9fc6833/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-292b23bb-0511-480b-8a2c-48cdf9fc6833/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}